module.exports = __webpack_public_path__ + "static/media/eh.44d97903.svg";